
// Vue
import {Options, Vue} from "vue-class-component";

// Vendors
import moment from "moment";

// Store
import store from "@/store/index";

// Models
import {AppCommonTraining} from "@/models/app/common/training";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
  ElDialog,
  ElForm,
  ElFormItem,
  ElDatePicker,
  ElButton,
} from "element-plus";
import {Calendar} from "@element-plus/icons-vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    ElDialog,
    ElForm,
    ElFormItem,
    ElDatePicker,
    ElButton,
    Calendar,
  },
})
export default class AppCoachPlayersProfileStatisticsTrainingsIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  formData: any = {
    filter: {
      user_id: "*",
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };
  formDataRules = {
    filter: {
      date: [
        {
          required: true,
          message: "Polje nije popunjeno",
          trigger: "blur",
        },
      ],
    },
  };

  moment: any = null;

  trainings: Array<AppCommonTraining> = [];
  statistics: Array<any> = [];

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.getFilteredData();
      }
    });
  }

  async getFilteredData(): Promise<void> {
    await this.getTrainings();
    await this.getStatistics();

    this.isDialogVisible = false;
  }

  async getStatistics(): Promise<void> {
    this.trainings.forEach((training: any) => {
      const statistic = this.statistics.filter((item: any) => {
        return item.training_category_id === training.training_category_id;
      });

      if (statistic.length === 0) {
        const fieldsOfNumbers = [];

        training.training_category.content.fields.forEach((field: any, key: number) => {
          if (field.type === "number") {
            fieldsOfNumbers.push({
              name: field.name,
              count: training.content.fields[key] ? training.content.fields[key].value ?? 0 : 0
            });
          }
        });

        this.statistics.push({
          name: training.training_category.content.name,
          training_category_id: training.training_category_id,
          count: 1,
          content: fieldsOfNumbers,
        });
      } else {
        this.statistics.forEach((statistic: any, statisticKey: number) => {
          if (statistic.training_category_id === training.training_category_id) {
            this.statistics[statisticKey].count = this.statistics[statisticKey].count + 1;

            training.training_category.content.fields.forEach((trainingField: any, trainingFieldKey: number) => {
              statistic.content.forEach((statisticField: any, statisticFieldKey: number) => {
                if (statisticField.name === trainingField.name) {
                  this.statistics[statisticKey].content[statisticFieldKey].count = this.statistics[statisticKey].content[statisticFieldKey].count + training.content.fields[trainingFieldKey].value ?? 0
                }
              });
            });
          }
        });
      }
    });
  }

  async getTrainings(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/trainings`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainings = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    this.formData.filter.user_id = this.$route.params.id;

    await this.getTrainings();
    await this.getStatistics();
  }
}
